export default __webpack_public_path__ + "static/gaku-laura-palates-af502e0fabc6d91f334db8bdafcb3b61.jpg";